import { render, staticRenderFns } from "./ProviderRecord.vue?vue&type=template&id=70a6e3fc&scoped=true&"
import script from "./ProviderRecord.vue?vue&type=script&lang=js&"
export * from "./ProviderRecord.vue?vue&type=script&lang=js&"
import style0 from "./ProviderRecord.vue?vue&type=style&index=0&id=70a6e3fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a6e3fc",
  null
  
)

export default component.exports